import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classes from './analytics.module.scss';
import Messages from './Messages/Messages';
import Answered from './Answered/Answered';
import AverageResponseTime from './AvarageResponseTime/AverageResponseTime';
import MessageVolume from './MessageVolume/MessageVolume';
import ActiveUsers from './ActiveUsers/ActiveUsers';
import ActiveAgents from './ActiveAgents/ActiveAgents';
import { getHealthRequest } from '../../../store/actions/healths';
import accountHelpers from '../../../utils/accountHelpers';
import Loader from '../../_common/Loader/Loader';

function Analytics({}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      // await dispatch(getHealthRequest({
      //   healthId: sessionStorage.getItem('healthPlan'),
      //   userId: accountHelpers.getUser().id,
      // }));
      setLoading(false);
    })();
  }, []);

  return (
  // loading ? <Loader />
  //   : (
    <div className={classes.wrapper}>
      <div className={classes.top}>
        <div className={classes.top_left}>
          <Messages />
        </div>

        <div className={classes.top_right}>
          <Answered />
        </div>
      </div>

      <div className={classes.middle}>
        <div className={classes.middle_left}>
          <AverageResponseTime />
        </div>

        <div className={classes.middle_right}>
          <MessageVolume />
        </div>
      </div>

      <div className={classes.bottom}>
        <div className={classes.bottom_left}>
          <ActiveUsers />
        </div>

        <div className={classes.bottom_right}>
          <ActiveAgents />
        </div>
      </div>
    </div>
  // )
  );
}

export default Analytics;
